import React from 'react';

import { Footer } from '../../containers';
import { Navbar, Email} from '../../components';
import './Spoudes&Epaggelmata.css';

const Spoudes = () => {
  return (
    <div className="Spoudes">
        <div className="gradient__bg">
          <Navbar />
        </div>
        <Email />
        <Footer />
    </div>
  )
}

export default Spoudes